import { render, staticRenderFns } from "./orderPayNot.vue?vue&type=template&id=72cd9f06&scoped=true&"
import script from "./orderPayNot.vue?vue&type=script&lang=js&"
export * from "./orderPayNot.vue?vue&type=script&lang=js&"
import style0 from "./orderPayNot.vue?vue&type=style&index=0&id=72cd9f06&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cd9f06",
  null
  
)

export default component.exports